import { useState } from 'react';
import { StaffMember, createStaffMember } from '@/services/staffService';
import { toast } from 'sonner';
import { useAuth } from '@/hooks/useAuth';

export const useStaffActions = (
  onStaffAdded?: () => void,
  setEditingStaff?: (staff: StaffMember | null) => void,
  setIsEditStaffDialogOpen?: (isOpen: boolean) => void
) => {
  const { organizationId } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleStaffAdded = async (staffData: any, continueToDetails?: boolean) => {
    if (!organizationId) {
      toast.error('Organization ID is required');
      return;
    }
    
    setIsLoading(true);
    try {
      const data = {
        ...staffData,
        organization_id: organizationId,
      };
      
      const newStaff = await createStaffMember(data);
      
      if (newStaff) {
        const successMessage = "Staff member created successfully";
        toast.success(successMessage);
        
        // Call the refresh callback
        if (onStaffAdded) {
          onStaffAdded();
        }
        
        // If continueToDetails is true, open the edit dialog
        if (continueToDetails && setEditingStaff && setIsEditStaffDialogOpen) {
          setEditingStaff(newStaff);
          setIsEditStaffDialogOpen(true);
        }
        
        return newStaff;
      }
    } catch (error) {
      console.error("Error adding staff member:", error);
      toast.error("Failed to create staff member", {
        description: error instanceof Error ? error.message : "Unknown error"
      });
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleStaffAdded,
    isLoading
  };
};